var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-section-header",class:{'sticky-section-header-fixed': _vm.isFixed}},[_c('div',{staticClass:"container container-small"},[_c('AccentHeader',{attrs:{"header":_vm.header,"underline":true,"uppercase":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }